import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

const SIDEBAR_HEADER_WIDTH = 384;
const HEADER_HEADER_HEIGHT = 52;

const ConversationsTitle = () => (
  <div
    className="mr-4 flex items-center border-b border-r px-4"
    style={{
      width: SIDEBAR_HEADER_WIDTH,
      height: HEADER_HEADER_HEIGHT,
    }}
  >
    <Typography.LabelMd weight="semibold" color="text-primary">
      {t("support_widget_v2.conversation_list_page.title")}
    </Typography.LabelMd>
  </div>
);

export default ConversationsTitle;
